export default class Marquee {
    constructor(element) {
        this.element = element;
        this.init();
    }

    init() {
        window.addEventListener("load", () => {
            this.element.classList.add("start-marquee");
        });
    }
}